import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-admin-study-update',
  templateUrl: './dialog-admin-study-update.component.html',
  styleUrls: ['./dialog-admin-study-update.component.scss']
})
export class DialogAdminStudyUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
